import { useState } from 'react';
import sound from './notification.wav';

const useAudio = () => {
  const [audio] = useState(new Audio(sound));

  const play = () => {
    audio.play();
  };

  const stop = () => {
    audio.pause();
  };

  return [play, stop];
};

export { useAudio };
